import React from "react";

const UrlLocation = ({
	register,
	error,
	required = false,
	className = "",
	id,
}) => {
	return (
		<input
			type="hidden"
			id={id}
			{...register(id)}
			value={window.location.href}
		/>
	);
};

export default UrlLocation;
